/* eslint-disable react/require-default-props */
import React from 'react';
import { Button, FlexColumn, FlexRow, Typography } from 'design-system';
import PreviewChoiceIndicator from './PreviewChoiceIndicator';
import { getOptionId, isSameId } from '../surveyPreviewUtils';

export default function RadioOptions({
  options,
  preview = false,
  value,
  onChange,
  interactive = false,
}) {
  if (!options.length) {
    return null;
  }

  const row = preview || options.length === 2;

  const optionButton = (option, index) => {
    const optionId = getOptionId(option, index);
    const selected = isSameId(value, optionId);

    return (
      <Button
        type="button"
        variant="link"
        className={[
          preview ? 'cc-preview-choice-option' : `radio-option mt-2 ${row ? 'mr-3' : 'w-100'}`,
          selected ? 'cc-preview-choice-option--selected' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        key={optionId}
        style={!preview && row ? { minWidth: '125px' } : undefined}
        aria-pressed={selected}
        disabled={!interactive}
        onClick={() => interactive && onChange?.(optionId)}
      >
        <FlexRow inline align="start" gap="var(--ds-space-2)">
          {preview ? (
            <PreviewChoiceIndicator type="radio" selected={selected} />
          ) : (
            <i className={`${selected ? 'fas fa-dot-circle' : 'far fa-circle'} fa-lg radio-option-icon`} aria-hidden />
          )}
          <Typography component="span" variant="body1" className="radio-option-label">
            {option.text}
          </Typography>
        </FlexRow>
      </Button>
    );
  };

  if (row) {
    return (
      <FlexRow
        wrap
        align="start"
        justify="start"
        style={{ columnGap: 'var(--ds-space-5)', rowGap: 'var(--ds-space-3)' }}
        className={preview ? 'cc-preview-choice-list' : ''}
        role="group"
      >
        {options.map(optionButton)}
      </FlexRow>
    );
  }

  return (
    <FlexColumn align="stretch" fullWidth role="group">
      {options.map(optionButton)}
    </FlexColumn>
  );
}
